import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/jmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/jmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/jmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/jmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/jmain/${Id}`);
  },
};
